module.exports = __webpack_public_path__ + "img/starbucks-status-panel.17830bfe.webp";